// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__19z6W","content":"GlobalSearch_content__2ue0L"};